import { I00DIMLIGNEGAZ_State } from '@batical/types/src'

const I00DIMLIGNEGAZ: I00DIMLIGNEGAZ_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  in_pci: 10.4,
  gaz_uuid: '7E3D48EC-7E15-4FB7-AE58-0D558DFBA0B3',
  in_pressionGaz: 200.0,
  in_temperatureGaz: 20.0,
  in_pressionAtmospherique: 0.0,
  in_nombreChaudiere: 0,
  in_puissanceChaudiere1: 0.0,
  in_puissanceChaudiere2: 0.0,
  in_puissanceChaudiere3: 0.0,
  in_puissanceChaudiere4: 0.0,
  in_longeurReseauPrincipal1: 0.0,
  in_longeurReseauPrincipal2: 0.0,
  in_longeurReseauPrincipal3: 0.0,
  in_longeurReseauPrincipal4: 0.0,
  in_longeurBranche1: 0.0,
  in_longeurBranche2: 0.0,
  in_longeurBranche3: 0.0,
  in_longeurBranche4: 0.0,
  in_nombreAccident1: 0.0,
  in_nombreAccident2: 0.0,
  in_nombreAccident3: 0.0,
  in_nombreAccident4: 0.0,
  in_gazMaterialIndex: 'Acier galvanisé',
  in_typeCalcul: 0,
  res_sectionPrincipale1: '',
  res_sectionPrincipale2: '',
  res_sectionPrincipale3: '',
  res_sectionPrincipale4: '',
  res_sectionSecondaire1: '',
  res_sectionSecondaire2: '',
  res_sectionSecondaire3: '',
  res_sectionSecondaire4: '',
  res_volumeBouteille: 0.0,
  mode: 'none',
  calcul_code: 'I00DIMLIGNEGAZ'
}

export default I00DIMLIGNEGAZ
